export function Hamburger() {
  return (
    <div className="hamburger peer-checked:active peer z-40 translate-y-[5px] peer-checked:fixed peer-checked:top-5 peer-checked:right-5 xl:hidden">
      <span className="hamburger-box">
        <span className="hamburger-inner" />
      </span>
    </div>
  );
}
